import { Component, lazy, Suspense } from "react";
import { handleStaleClientFailure, isStaleClientError } from "../../utils/staleClientRecovery";
import StaleClientPrompt from "./StaleClientPrompt";

function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      Loading…
    </div>
  );
}

class LazyRouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    handleStaleClientFailure(error);
  }

  render() {
    if (this.state.error && isStaleClientError(this.state.error)) {
      return (
        <div className="route-fallback">
          <StaleClientPrompt compact />
        </div>
      );
    }
    if (this.state.error) {
      return (
        <div className="route-fallback" role="alert">
          Something went wrong loading this page. Try refreshing.
        </div>
      );
    }
    return this.props.children;
  }
}

/** Route-level code split. The page chunk loads only when the route is shown. */
export function lazyPage(factory) {
  const Page = lazy(factory);

  function LazyRoute(props) {
    return (
      <LazyRouteErrorBoundary>
        <Suspense fallback={<RouteFallback />}>
          <Page {...props} />
        </Suspense>
      </LazyRouteErrorBoundary>
    );
  }

  return LazyRoute;
}
